import URLUtils from "../../data-amazon_api_gateway/URLUtils";
import SignatoryRepository from "../data/SignatoryRepository";
import UserRepository from "../data/UserRepository";
import Signatory, { SignatoryLogin } from "../entities/Signatory";
import User from "../entities/User";

export const baseURL: any = URLUtils.getBaseURL();

export default class SessionInteractor {
  private userRepository: UserRepository;
  private signatoryRepository: SignatoryRepository;

  constructor(
    userRepository: UserRepository,
    signatoryRepository: SignatoryRepository
  ) {
    this.userRepository = userRepository;
    this.signatoryRepository = signatoryRepository;
  }

  public async login(
    username: string,
    password: string
  ): Promise<User[] | Signatory | undefined> {
    return this.userRepository.login(username, password);
  }

  public async cognitoAuthLogin(
    username: string,
    password: string
  ): Promise<User[] | Signatory | undefined> {
    return this.userRepository.cognitoAuthLogin(username, password);
  }

  public async cognitoNewPasswordLogin(
    username: string,
    tempPassword: string,
    newPassword: string
  ): Promise<User[] | Signatory | undefined> {
    return this.userRepository.cognitoNewPasswordLogin(username, tempPassword, newPassword);
  }

  public async loginExternal(
    shortId: string,
    password: string
  ): Promise<User[] | SignatoryLogin | undefined> {
    //return this.signatoryRepository.getSignatoryByShortId(shortId);
    return this.signatoryRepository.getSignatoryByShortIdThenVerify(
      shortId,
      password
    );
  }


  public async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    return this.userRepository.changePassword(currentPassword, newPassword);
  }

  public async requestPasswordUpdate(email: string): Promise<boolean> {
    return this.userRepository.requestPasswordUpdate(email);
  }

  public async passwordUpdate(
    email: string,
    password: string,
    resetCode: string
  ): Promise<boolean> {
    return this.userRepository.passwordUpdate(email, password, resetCode);
  }

  public async cognitoDecode(tokenUrlencoded: URLSearchParams): Promise<User[]> {
    return this.userRepository.cognitoDecode(tokenUrlencoded);
  }

  public async cognitoVerify(codeUrlencoded: URLSearchParams): Promise<any> {
    return this.userRepository.cognitoVerify(codeUrlencoded);
  }

  public async mfaRespond(username: string, session: string, code: string): Promise<any> {
    return this.userRepository.mfaRespond(username, session, code);
  }

  public async mfaSetup(accessToken: string): Promise<{ secretCode: string; email: string }> {
    return this.userRepository.mfaSetup(accessToken);
  }

  public async mfaVerifySetup(accessToken: string, code: string): Promise<{ status: string }> {
    return this.userRepository.mfaVerifySetup(accessToken, code);
  }
}
